const growthBookConfig = {
  apiHost: process.env.GROWTHBOOK_API_HOST || "",
  clientKey: process.env.GROWTHBOOK_CLIENT_KEY || "",
  enableDevMode: process.env.GROWTHBOOK_DEV_MODE === "true" || false,
};

export default growthBookConfig;
